let Medscape = window.Medscape || {}
Medscape.ArticlePage = Medscape.ArticlePage || {};
Medscape.modules = Medscape.modules || {};
window.Medscape = Medscape;

export { Medscape }